<template>
	<p class="filterable-list__list-item-description">
		<slot></slot>
	</p>
</template>
